import { Component, Input, OnInit } from '@angular/core';
import { pairwise, startWith } from 'rxjs';

@Component({
    selector: 'app-staff-final-preview',
    templateUrl: './staff-final-preview.component.html',
    styleUrls: ['./staff-final-preview.component.scss'],
    standalone: false
})
export class StaffFinalPreviewComponent implements OnInit {
  @Input() form: any = {};
  @Input() step: any;
  @Input() isEdit: boolean = false;

  public staffInformation: any = {};
  public staffDetail: any = {};
  public staffAddress: any = {};
  public salary: any = {};
  public certifications: any = {};
  verifyExpiration_dateAndFile_name: any;
  constructor() {}

  ngOnInit(): void {
    this.form
      .get('step01')
      .valueChanges.pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        this.staffInformation = next?.staffInformation;
      });

    this.form
      .get('step02')
      .valueChanges.pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        this.staffDetail = next?.staffDetail;
      });

    this.form
      .get('step03')
      .valueChanges.pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        this.staffAddress = next?.staffAddress;
      });

    this.form
      .get('step04')
      .valueChanges.pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        this.salary = next?.salary;
      });

    this.form
      .get('step05')
      .valueChanges.pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        this.certifications = next?.certifications;
        this.verifyExpiration_dateAndFile_name = this.certifications;
      });
  }

  hasValidCertifications(): boolean {
    return this.certifications.certificates.some(
      (certification: any) =>
        certification.expiration_date !== null ||
        certification.file_name !== null
    );
  }

  getFileName(image: any) {
    const urlParts = image.split('/');
    return urlParts[urlParts.length - 1];
  }
}
